import { render, staticRenderFns } from "./RechargeIndex.vue?vue&type=template&id=6e054ffc&scoped=true"
import script from "./RechargeIndex.vue?vue&type=script&lang=js"
export * from "./RechargeIndex.vue?vue&type=script&lang=js"
import style0 from "./RechargeIndex.vue?vue&type=style&index=0&id=6e054ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e054ffc",
  null
  
)

export default component.exports